export default function isMacOs(): boolean {
  let isMacOs = false;
  if (typeof window !== 'undefined') {
    isMacOs = window?.navigator.platform.toUpperCase().indexOf('MAC') >= 0;
  }
  return isMacOs;
}
